import { useSelector } from 'react-redux';
import { selectLineItems } from '../../../state/BudgetList/budgetListSlice';
import { selectTeamProjects } from '../../../state/Projects/projectsSlice';
import { selectLearningTeams } from '../../../state/LearningTeams/learningTeamsSlice';
import { selectAllPrograms } from '../../../state/Programs/programsSlice';
import {
  LineItemWithAmounts,
  ProjectToProgramMap,
} from '../../../utils/customTypes';
import { useMemo } from 'react';

const useBrokenBudgetOptions = () => {
  const lineItems = useSelector(selectLineItems);
  const projects = useSelector(selectTeamProjects);
  const teams = useSelector(selectLearningTeams);
  const programs = useSelector(selectAllPrograms);

  const projectToProgramMap: ProjectToProgramMap = useMemo(() => {
    return programs.reduce((map: Record<string, Set<string>>, program) => {
      program.programProjects.forEach((project) => {
        if (!map[project.id]) {
          map[project.id] = new Set();
        }
        map[project.id].add(program.id);
      });
      return map;
    }, {});
  }, [programs]);

  const brokenLineItems: LineItemWithAmounts[] = useMemo(() => {
    return lineItems.filter((lineItem) => {
      const isProjectProgramBroken =
        lineItem.projectId &&
        lineItem.programId &&
        !projectToProgramMap[lineItem.projectId]?.has(lineItem.programId);

      return isProjectProgramBroken;
    });
  }, [lineItems, projectToProgramMap]);

  return {
    projectToProgramMap,
    brokenLineItems,
    programs,
    projects,
    teams,
  };
};

export default useBrokenBudgetOptions;
